import { Link } from "react-router-dom";
import type { BeautyArticle } from "@/mocks/beauty-info";
import { scrollToTop } from "@/components/feature/ScrollToTop";

interface ArticleNavProps {
  prev: BeautyArticle | null;
  next: BeautyArticle | null;
}

export default function ArticleNav({ prev, next }: ArticleNavProps) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {prev ? (
        <Link
          to={`/beauty-info/${prev.id}`}
          onClick={scrollToTop}
          className="group flex items-center gap-4 rounded-2xl border border-background-200/70 bg-white p-5 transition-all hover:border-primary-200 cursor-pointer"
        >
          <span className="w-10 h-10 shrink-0 rounded-full bg-primary-50 flex items-center justify-center text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors">
            <i className="ri-arrow-left-line"></i>
          </span>
          <span className="flex flex-col gap-1 min-w-0">
            <span className="text-xs text-foreground-500">이전 글</span>
            <span className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-1 group-hover:text-primary-600 transition-colors">
              {prev.title}
            </span>
          </span>
        </Link>
      ) : (
        <span className="hidden sm:block" />
      )}

      {next ? (
        <Link
          to={`/beauty-info/${next.id}`}
          onClick={scrollToTop}
          className="group flex items-center justify-end gap-4 rounded-2xl border border-background-200/70 bg-white p-5 text-right transition-all hover:border-primary-200 cursor-pointer"
        >
          <span className="flex flex-col gap-1 min-w-0">
            <span className="text-xs text-foreground-500">다음 글</span>
            <span className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-1 group-hover:text-primary-600 transition-colors">
              {next.title}
            </span>
          </span>
          <span className="w-10 h-10 shrink-0 rounded-full bg-primary-50 flex items-center justify-center text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors">
            <i className="ri-arrow-right-line"></i>
          </span>
        </Link>
      ) : (
        <span className="hidden sm:block" />
      )}
    </div>
  );
}